import moment from 'moment';
import { DBO_TM } from '@op/utils/format';
import { defaultValueKeyList } from '@opm/components/FilterCommon/constants/timeRange';

export function dealwithHashtag(id: string) {
  return (data: { config: any }) => {
    const config = data.config[id];
    if (!config) {
      return {};
    }

    // Prioritize default_country data (country=us) over top-level (country=all)
    const defaultCountry = config?.default_country;
    const sourceConfig = defaultCountry || config;
    let defaultFilter: Record<string, any> = {};
    let time = '';
    let timeRange = '';
    defaultValueKeyList.some(key => {
      if (sourceConfig[key]) {
        timeRange = key;
        time = sourceConfig[key];
        return true;
      }
      return false;
    });

    // Set default countries from default_country.countries
    if (sourceConfig?.countries?.length) {
      defaultFilter.countries = [...sourceConfig.countries];
    }

    if (time) {
      defaultFilter = {
        ...defaultFilter,
        ...DBO_TM.serverTimeObj([time, time], 'daily'),
        time_range: timeRange,
        date_type: 'daily',
      };
    }

    return { defaultFilter };
  };
}

const ALL_HOURS = Array.from({ length: 24 }, (_, i) =>
  String(i).padStart(2, '0'),
);

/**
 * Bilibili Hashtag 专用：解析 config 中的 has_data_date，
 * 拆分为 start_time / end_time（给 FilterCommon）和 startHour / endHour / hours（给 TimeRangeSelect）。
 * 无 has_data_date 时返回默认全天值，组件无需处理 fallback。
 */
export function dealwithBilibiliHashtag(id: string) {
  return (data: { config: any }) => {
    const config = data.config[id];

    const hasDataDate: string | undefined = config?.has_data_date;
    const m = moment(hasDataDate);
    const dateStart = m.clone().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    const dateEnd = m.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    // if (hasDataDate) {
    //   const m = moment(hasDataDate);
    //   const dateStart = m.clone().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    //   const dateEnd = m.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    //   const hour = m.hour();

    //   return {
    //     defaultFilter: {
    //       start_time: dateStart,
    //       end_time: dateEnd,
    //     },
    //     hasDataDateRange: {
    //       startHour: moment({ hour: 0 }).format('HH:mm'),
    //       endHour: moment({ hour }).format('HH:mm'),
    //       hours: Array.from({ length: hour + 1 }, (_, i) =>
    //         moment({ hour: i }).format('HH'),
    //       ),
    //     },
    //     hasData: false,
    //   };
    // }

    return {
      defaultFilter: {
        start_time: dateStart,
        end_time: dateEnd,
      },
      hasDataDateRange: {
        startHour: '00:00',
        endHour: '24:00',
        hours: ALL_HOURS,
      },
      hasData: false,
    };
  };
}

/**
 * Douyin Hashtag 专用：解析 config 中的 has_data_date（日粒度），
 * 返回单日 defaultFilter（start_time / end_time / date_type）。
 * 无 has_data_date 时（有数据场景）回退到 UTC+8 今天，组件无需处理 fallback。
 */
export function dealwithDouyinHashtag(id: string) {
  return (data: { config: any }) => {
    const config = data.config[id];

    const hasDataDate: string | undefined = config?.has_data_date;
    const m = moment(hasDataDate);
    return {
      defaultFilter: {
        start_time: m.clone().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end_time: m.clone().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        date_type: 'daily',
      },
    };
  };
}

/**
 * TODO: 暂时未使用
 * @param id
 * @returns
 */
export function dealwithVideo(id: string) {
  return (data: { config: any }) => {
    const config = data.config[id];
    if (!config) {
      return {};
    }
    let time = '';
    let channels = '';
    ['tiktok', 'youtube'].some(key => {
      if (config[key]) {
        channels = key;
        time = config[key];
        return true;
      }
      return false;
    });

    if (time) {
      return {
        defaultFilter: {
          ...DBO_TM.serverTimeObj([time, time], 'daily'),
          channels,
          date_type: 'daily',
        },
      };
    }

    return {};
  };
}
